import React from 'react';
import PropTypes from 'prop-types';

import { Box, ButtonFilled } from 'Components/Base';

import { TextTitle, TextDescription } from '../Components/TextContent';
import { CardWrapper, ContentWrapper } from '../Components/WrapperContent';

const TimeUpdate = ({ statusList, refetchByteArk }) => {
  const currentDate = new Date();
  const date = currentDate.toLocaleDateString('th-TH', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
  const time = currentDate.toLocaleTimeString('th-TH', {
    hour: 'numeric',
    minute: 'numeric',
  });
  const dateTime = `${date}, เวลา ${time} น.`;

  const refetch = () => {
    statusList.forEach((status) => {
      status.refetch();
    });
    refetchByteArk();
  };

  return (
    <>
      <ContentWrapper gridTemplateColumns={'1fr'}>
        <CardWrapper flexDirection={{ _: 'column', md: 'row' }} alignItems="center">
          <Box flex={1} textAlign={{ _: 'center', md: 'start' }}>
            <TextTitle>อัปเดตล่าสุด</TextTitle>
            <TextDescription>{dateTime}</TextDescription>
          </Box>
          <ButtonFilled
            width={{ _: 1, md: 'auto' }}
            mt={{ _: 6, md: 0 }}
            color={'warning'}
            textColor={'text'}
            onClick={refetch}
          >
            ตรวจสอบอีกครั้ง
          </ButtonFilled>
        </CardWrapper>
      </ContentWrapper>
    </>
  );
};

TimeUpdate.propTypes = {
  statusList: PropTypes.array,
  refetchByteArk: PropTypes.func,
};

export default TimeUpdate;
